var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"boxi"},[_c('div',{staticClass:"textinBox text-center"},[_c('h4',[_vm._v(_vm._s(_vm.$t('feeds_module.comingsoon')))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }